/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Select_Folder_TitleInputs */



/**
* | output |
* | --- |
* | "Export Images - Select Folder" |
*
* @param {Image_Export_Select_Folder_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_select_folder_title = /** @type {((inputs?: Image_Export_Select_Folder_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Select_Folder_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter les images - Selectionner un dossier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bilder exportieren – Ordner auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta immagini - Seleziona cartella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт изображений - Выберите папку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar imágenes - Seleccionar carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出图像 - 选择文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("画像をエクスポート - フォルダを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इमेज एक्सपोर्ट करें - फ़ोल्डर चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar imagens - Selecionar pasta")
	return /** @type {LocalizedString} */ ("Export Images - Select Folder")
});